import ProjectSession from "../../../../model2/project/project-session"
import {ProjectSystemTypeName} from "../../../../model2/project/types"
import {SystemStatus} from "../../../../gd/const/system-status"
import Project_updateSystemStatus from "../../../../model2/project/actions/update-system-status"

export default function archive_project(project:ProjectSession) {

    gd.modals.confirm.genericText('Archive '+project.name, 'Are you sure that you want to archive this '+ProjectSystemTypeName[project.systemType], async ()=>{
        Project_updateSystemStatus(project, SystemStatus.COMPLETED)
        gd.modal.hide()
    })
}